// Peak Plumbing — City & County registry with dynamic content injection.
//
// Uniqueness strategy (to comply with Google's Scaled Content policy):
//   1. County context — Macomb County pages emphasise cast-iron/clay sewer
//      mains and combined-sewer surcharge issues; Oakland County pages
//      emphasise well systems and hard water. Content is materially different
//      per county.
//   2. Deterministic per-city variants for tagline / intro / recent job — same
//      city always renders the same copy, but different cities render
//      different combinations.
//   3. Localized FAQ — each city page renders a FAQ block with city name,
//      county, ZIP and service-radius specifics, on top of the shared base
//      FAQ.
//   4. Service pages combine core-service copy with county-specific challenges
//      so the same service on Troy vs. Roseville reads meaningfully differently.

const MACOMB = [
  { name: "Armada", slug: "armada", zip: "48005" },
  { name: "Center Line", slug: "center-line", zip: "48015" },
  { name: "Chesterfield", slug: "chesterfield", zip: "48047" },
  { name: "Clinton Township", slug: "clinton-township", zip: "48035" },
  { name: "Eastpointe", slug: "eastpointe", zip: "48021" },
  { name: "Fraser", slug: "fraser", zip: "48026" },
  { name: "Harrison Township", slug: "harrison-township", zip: "48045" },
  { name: "Lenox Township", slug: "lenox-township", zip: "48050" },
  { name: "Macomb Township", slug: "macomb-township", zip: "48042" },
  { name: "Memphis", slug: "memphis", zip: "48041" },
  { name: "Mount Clemens", slug: "mount-clemens", zip: "48043" },
  { name: "New Baltimore", slug: "new-baltimore", zip: "48047" },
  { name: "New Haven", slug: "new-haven", zip: "48048" },
  { name: "Ray Township", slug: "ray-township", zip: "48096" },
  { name: "Richmond", slug: "richmond", zip: "48062" },
  { name: "Romeo", slug: "romeo", zip: "48065" },
  { name: "Roseville", slug: "roseville", zip: "48066" },
  { name: "Shelby Township", slug: "shelby-township", zip: "48316" },
  { name: "St. Clair Shores", slug: "st-clair-shores", zip: "48080" },
  { name: "Sterling Heights", slug: "sterling-heights", zip: "48310" },
  { name: "Utica", slug: "utica", zip: "48317" },
  { name: "Warren", slug: "warren", zip: "48088" },
  { name: "Washington Township", slug: "washington-township", zip: "48094" },
].map((c) => ({ ...c, county: "Macomb County" }));

const OAKLAND = [
  { name: "Auburn Hills", slug: "auburn-hills", zip: "48326" },
  { name: "Berkley", slug: "berkley", zip: "48072" },
  { name: "Beverly Hills", slug: "beverly-hills", zip: "48025" },
  { name: "Bingham Farms", slug: "bingham-farms", zip: "48025" },
  { name: "Birmingham", slug: "birmingham", zip: "48009" },
  { name: "Bloomfield Hills", slug: "bloomfield-hills", zip: "48302" },
  { name: "Bloomfield Township", slug: "bloomfield-township", zip: "48301" },
  { name: "Clarkston", slug: "clarkston", zip: "48346" },
  { name: "Clawson", slug: "clawson", zip: "48017" },
  { name: "Commerce Township", slug: "commerce-township", zip: "48382" },
  { name: "Farmington", slug: "farmington", zip: "48331" },
  { name: "Farmington Hills", slug: "farmington-hills", zip: "48331" },
  { name: "Ferndale", slug: "ferndale", zip: "48220" },
  { name: "Franklin", slug: "franklin", zip: "48025" },
  { name: "Groveland Township", slug: "groveland-township", zip: "48462" },
  { name: "Hazel Park", slug: "hazel-park", zip: "48030" },
  { name: "Highland Township", slug: "highland-township", zip: "48356" },
  { name: "Holly", slug: "holly", zip: "48442" },
  { name: "Huntington Woods", slug: "huntington-woods", zip: "48070" },
  { name: "Independence Township", slug: "independence-township", zip: "48346" },
  { name: "Keego Harbor", slug: "keego-harbor", zip: "48320" },
  { name: "Lake Angelus", slug: "lake-angelus", zip: "48326" },
  { name: "Lake Orion", slug: "lake-orion", zip: "48360" },
  { name: "Lathrup Village", slug: "lathrup-village", zip: "48076" },
  { name: "Leonard", slug: "leonard", zip: "48367" },
  { name: "Lyon Township", slug: "lyon-township", zip: "48178" },
  { name: "Madison Heights", slug: "madison-heights", zip: "48071" },
  { name: "Milford", slug: "milford", zip: "48381" },
  { name: "Northville", slug: "northville", zip: "48167" },
  { name: "Novi", slug: "novi", zip: "48375" },
  { name: "Oak Park", slug: "oak-park", zip: "48237" },
  { name: "Oakland Township", slug: "oakland-township", zip: "48306" },
  { name: "Orchard Lake Village", slug: "orchard-lake-village", zip: "48324" },
  { name: "Orion Township", slug: "orion-township", zip: "48359" },
  { name: "Ortonville", slug: "ortonville", zip: "48462" },
  { name: "Oxford", slug: "oxford", zip: "48371" },
  { name: "Pleasant Ridge", slug: "pleasant-ridge", zip: "48069" },
  { name: "Pontiac", slug: "pontiac", zip: "48342" },
  { name: "Rochester", slug: "rochester", zip: "48307" },
  { name: "Rochester Hills", slug: "rochester-hills", zip: "48309" },
  { name: "Rose Township", slug: "rose-township", zip: "48442" },
  { name: "Royal Oak", slug: "royal-oak", zip: "48067" },
  { name: "South Lyon", slug: "south-lyon", zip: "48178" },
  { name: "Southfield", slug: "southfield", zip: "48075" },
  { name: "Springfield Township", slug: "springfield-township", zip: "48350" },
  { name: "Sylvan Lake", slug: "sylvan-lake", zip: "48320" },
  { name: "Troy", slug: "troy", zip: "48083" },
  { name: "Walled Lake", slug: "walled-lake", zip: "48390" },
  { name: "Waterford Township", slug: "waterford-township", zip: "48328" },
  { name: "West Bloomfield Township", slug: "west-bloomfield-township", zip: "48322" },
  { name: "White Lake Township", slug: "white-lake-township", zip: "48383" },
  { name: "Wixom", slug: "wixom", zip: "48393" },
  { name: "Wolverine Lake", slug: "wolverine-lake", zip: "48390" },
].map((c) => ({ ...c, county: "Oakland County" }));

export const CITY_LIST = [...MACOMB, ...OAKLAND];
export const MACOMB_CITIES = MACOMB;
export const OAKLAND_CITIES = OAKLAND;
export const CITIES = CITY_LIST.reduce((acc, c) => {
  acc[c.slug] = c;
  return acc;
}, {});

// ----------------------------------------------------------------
// County-level context (drives materially different content per page)
// ----------------------------------------------------------------
export const COUNTY_CONTEXT = {
  "Macomb County": {
    housing:
      "Macomb County housing skews toward post-war ranches and 1960s–70s brick homes on municipal water and sewer. Many still have their original cast-iron drain stacks and clay sewer laterals — both of which are vulnerable to root intrusion and cracking after 50+ years in Michigan clay soil.",
    weather:
      "Freeze–thaw cycles from November through March put a lot of stress on outdoor hose bibbs, unheated crawlspace pipes, and shallow water service lines.",
    challenges: [
      "Older clay and cast-iron sewer mains prone to tree-root intrusion",
      "Combined-sewer surcharges causing basement backups after heavy rain",
      "Freeze-ups on older, shallow-buried water service lines",
      "Frost heave and settling around excavated repairs",
    ],
    servicePriority: ["drain-cleaning", "sewer-line-repair", "sump-pumps", "emergency-plumbing"],
    utility: "Great Lakes Water Authority / local municipal",
    permit: "Most plumbing work in Macomb County requires a permit through the municipality's building department; we pull permits when the scope requires it.",
  },
  "Oakland County": {
    housing:
      "Oakland County is much more varied — historic Birmingham and Royal Oak homes, mid-century Southfield and Farmington Hills subdivisions, and newer builds on private wells in Milford, Highland, Holly and Rose Township. Water quality and well maintenance are major concerns for a large share of homeowners.",
    weather:
      "Similar Michigan freeze exposure, plus lakefront properties around Orchard Lake, Cass Lake and White Lake with elevated groundwater tables year-round.",
    challenges: [
      "Hard well water requiring softener and iron/sulfur filtration",
      "Submersible well pump and pressure-switch failures on aging systems",
      "High water tables and lakefront basements needing reliable sump systems",
      "Copper pipe pin-hole leaks in older Birmingham and Bloomfield homes",
    ],
    servicePriority: ["water-treatment-well-services", "sump-pumps", "water-heaters", "leak-detection"],
    utility: "Municipal (Detroit Water) or private well",
    permit: "Plumbing permits are pulled through Oakland County's respective municipal building departments; wells and septic-adjacent work also require county health department review.",
  },
};

// ----------------------------------------------------------------
// Deterministic pseudo-random helpers for per-city variation
// ----------------------------------------------------------------
const hashSlug = (slug) => {
  let h = 0;
  for (let i = 0; i < slug.length; i++) h = (h * 31 + slug.charCodeAt(i)) >>> 0;
  return h;
};
const pick = (arr, slug, offset = 0) => arr[(hashSlug(slug) + offset) % arr.length];

const TAGLINE_TEMPLATES = [
  (n) => `${n}'s dependable, family-owned plumbing team.`,
  (n) => `Trusted plumbing service for ${n} homeowners.`,
  (n) => `${n} calls Peak Plumbing when they need it done right.`,
  (n) => `Honest, upfront plumbing for ${n}, MI.`,
  (n) => `${n}'s go-to team for drains, sewers, and water heaters.`,
];

const INTRO_TEMPLATES = [
  (n, county) =>
    `Peak Plumbing has been serving ${n}, MI homeowners with careful, thorough plumbing work for years. As a ${county}-focused, family-owned company, we know the housing stock, the soil, and the common failure points here better than anyone rolling in from further away.`,
  (n, county) =>
    `When something goes wrong with the plumbing in your ${n} home, you want a team that shows up, explains the problem in plain English, and gives you a fair fixed price before starting. That's how Peak Plumbing has been serving ${n} and the rest of ${county}.`,
  (n, county) =>
    `From single-drip repairs to complete sewer line replacements, Peak Plumbing handles every kind of plumbing work in ${n}. Our ${county} focus means we're deeply familiar with the specific issues homes in this area face year after year.`,
];

// ----------------------------------------------------------------
// County + service intersection copy — this is the primary uniqueness lever.
// A given (county, service) pair produces materially different paragraphs
// than any other pair.
// ----------------------------------------------------------------
const COUNTY_SERVICE_COPY = {
  "Macomb County": {
    "drain-cleaning":
      "Because so many Macomb County homes still run their original cast-iron drain stacks and clay sewer laterals, drain issues here often go deeper than a simple clog. We camera-inspect first when the symptoms don't add up — it saves customers money on unnecessary repairs.",
    "water-heaters":
      "Macomb County's mineral load is moderate on municipal water, so annual sediment flushing meaningfully extends water heater life. Older ranch homes often have undersized units for modern demand — we can help you size the right replacement.",
    "sewer-line-repair":
      "The vast majority of sewer failures we see in Macomb County are on original clay or cast-iron laterals with tree roots and corrosion. Excavation-based repair is often the right long-term answer, especially where the pipe has partially collapsed.",
    "water-treatment-well-services":
      "Most Macomb County homes are on municipal water, but we do handle whole-home softeners and drinking-water filtration for customers who want cleaner water at every tap.",
    "leak-detection":
      "Older Macomb County housing stock hides quite a bit of copper and galvanized piping in walls and slabs. Non-invasive leak detection saves customers from unnecessary drywall damage.",
    "fixture-repair":
      "Fixture repair in older Macomb County homes often means dealing with corroded shutoffs and non-standard drain configurations. We come prepared for that instead of surprising you with change-orders.",
    "sump-pumps":
      "Combined-sewer surcharges during heavy Macomb County rain events are the single biggest reason we recommend reliable sump systems with battery backup here. Basement backups are prevalent in low-lying neighborhoods.",
    "emergency-plumbing":
      "Winter freeze-ups on shallow-buried service lines and sump-pump failures during summer storms account for most Macomb County emergency calls we take.",
  },
  "Oakland County": {
    "drain-cleaning":
      "Oakland County drain issues are all over the map — from mineral-scaled well-water systems in Milford and Rose Township to root-intruded clay mains in older Southfield and Farmington homes. Camera inspection tells us which situation we're in.",
    "water-heaters":
      "Oakland County has a wide split between city water and well water — and well water dramatically shortens water-heater life without proper conditioning upstream. We recommend water quality testing before a big install.",
    "sewer-line-repair":
      "Sewer failures in Oakland County range from root-cracked older lines in Birmingham and Royal Oak to slope/settling issues in newer subdivisions. We diagnose before we quote.",
    "water-treatment-well-services":
      "A huge chunk of Oakland County — Milford, Highland, Rose Township, Groveland — relies on private wells with the classic Michigan water problems: hardness, iron, sometimes sulfur. Proper conditioning is the difference between fixtures that last and fixtures that stain.",
    "leak-detection":
      "Copper pin-hole leaks are a well-known problem in older Birmingham and Bloomfield homes. We locate them non-invasively so repairs are surgical rather than exploratory.",
    "fixture-repair":
      "Higher-end Oakland County homes often have imported and specialty fixtures. We work with the manufacturer's parts rather than universal-fit shortcuts.",
    "sump-pumps":
      "Lakefront and high-water-table properties across Oakland County — around Cass Lake, Orchard Lake, White Lake — demand oversized primary pumps and battery backups. Undersizing is the #1 cause of the pump 'failures' we see.",
    "emergency-plumbing":
      "Well pump failures on rural Oakland County properties and burst copper in older core-city homes are our two most common emergency calls in this county.",
  },
};

export function getCountyServiceCopy(city, serviceSlug) {
  return COUNTY_SERVICE_COPY[city.county]?.[serviceSlug] || "";
}

// ----------------------------------------------------------------
// Localized FAQ generator — layers city-specific questions on top of a base
// FAQ set. Each city gets a materially different FAQ block.
// ----------------------------------------------------------------
export function getLocalizedFaqs(city) {
  const county = COUNTY_CONTEXT[city.county];
  const responseWindow =
    city.county === "Macomb County" ? "typically within 45–75 minutes" : "typically within 60–90 minutes";

  return [
    {
      q: `How quickly can Peak Plumbing get to ${city.name}?`,
      a: `Because Peak Plumbing is based in Roseville, we can usually be at a ${city.name}, MI address ${responseWindow} during our operating hours. Emergency calls get priority routing.`,
    },
    {
      q: `Do you pull plumbing permits in ${city.name}?`,
      a: `${county.permit} For projects in ${city.name} that require a permit, we pull it, coordinate inspection, and provide documentation to you at closeout.`,
    },
    {
      q: `What are the most common plumbing issues you see in ${city.name}?`,
      a: `${county.challenges[0]}. We also see ${county.challenges[1].toLowerCase()} across ${city.name} and the surrounding ${city.county} area.`,
    },
    {
      q: `Do you serve every ZIP code in ${city.name}?`,
      a: `Yes. ${city.name}'s ZIP ${city.zip} and any surrounding ZIP codes are all inside our regular service area. Call ${"(586) 351-6271"} and we'll confirm scheduling for your address.`,
    },
    {
      q: `Do you handle both residential and commercial plumbing in ${city.name}?`,
      a: `Yes — Peak Plumbing serves homeowners and small commercial properties throughout ${city.name}, MI. Larger commercial projects we scope and quote in person.`,
    },
  ];
}

// ----------------------------------------------------------------
// Per-city summary content
// ----------------------------------------------------------------
export function getCityContent(city) {
  const county = COUNTY_CONTEXT[city.county];
  const tagline = pick(TAGLINE_TEMPLATES, city.slug, 0)(city.name);
  const intro = pick(INTRO_TEMPLATES, city.slug, 1)(city.name, city.county);

  return {
    tagline,
    intro,
    countyHousing: county.housing,
    countyWeather: county.weather,
    challenges: county.challenges,
    servicePriority: county.servicePriority,
  };
}
